import { render, staticRenderFns } from "./TaskSceneInfo.vue?vue&type=template&id=555238c2"
import script from "./TaskSceneInfo.vue?vue&type=script&lang=js"
export * from "./TaskSceneInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports